<app-menu [hasChanges]="loadMenu"></app-menu>
<app-loading [show]="load"></app-loading>
<div class="m-2">
    <div class="p-fluid pl-2">
        <h2 class="uppercase">Listado de cotizaciones </h2>
    </div>
</div>
<div class="flex flex-wrap w-full mt-3 p-3 bg-gray-50">
    <div class="gap-2 p-2 w-full md:w-6">
        <label class="uppercase">Seleccione un rango de fechas de consulta</label>
        <p-datepicker [(ngModel)]="rangeDates" [showWeek]="false" appendTo="body" #calendar selectionMode="range"
            [readonlyInput]="true" dateFormat="yy-mm-dd" [showIcon]="true" [styleClass]="'w-full'"
            (onSelect)="onSelectDate($event)"></p-datepicker>
    </div>
    <div class="gap-2 p-2 w-full md:w-6">
        <label class="uppercase">Seleccione el estado</label>
        <p-select [options]="statesQuotation" [(ngModel)]="selectedStateQuotation" optionLabel="name"
            placeholder="Seleccione un estado de la cotización" (onChange)="getInfo()" />
    </div>

    <div class="w-full flex pl-2 pr-2" *ngIf="lsCotizacion.length >0">
        <div class="p-inputgroup">
            <div class="p-inputgroup-addon">
                <i class="pi pi-search"></i>
            </div>
            <input type="text" autocomplete="nope" pInputText [(ngModel)]="txtFiltro"
                placeholder="Filtro de información por razón social o número de cotización" (keyup)="filterInfo()">
        </div>
    </div>
</div>
<div class="p-2" *ngFor="let row of lsCotizacionFilter">
    <p-card [style]="{ width: '100%', padding:'5px' }">
        <p-header>
            <div class="flex justify-content-between">
                <div>
                    <h4>{{(row.idClienteNavigation.razonSocial.replace('/') !='NA'?row.idClienteNavigation.razonSocial:
                        row.idClienteNavigation.nombres) | uppercase}}</h4>
                </div>
                <button *ngIf="row.idCotizacionNavigation.estado==2" pButton label="Reenviar correo"
                    icon="pi pi-envelope" class="p-button p-button-link" (click)="toSeeDisplayForward(row)"></button>
            </div>
        </p-header>

        <div class="flex flex-wrap p-2">
            <div class="w-full md:w-6">
                <!-- Lista de Precios : {{row.idListaPreciosNavigation?.nombreListaPrecios}}<br>
                Canal de Venta:{{row.idCanalVentaNavigation?.descripcion}}<br> -->
                Nro. Cotización: {{row.idCotizacionNavigation.idCotizacion}} <a class="p-button p-button-link m-0 p-0"
                    (click)="toSeeDetail(row.idCotizacionNavigation.idCotizacion)"><i class="pi pi-eye"></i>&nbsp; Ver
                    detalle</a><br>
                Fecha de creación: {{row.idCotizacionNavigation.fechaCreacion | date}} <br>
                Fecha de cierre: <span>{{row.idCotizacionNavigation.estado==2 ? (row.idCotizacionNavigation.fechaCierre
                    | date) : 'En proceso'}}</span>

                Subtotal: {{row.subtotal | currency}} | Impuesto: {{row.impuesto | currency}}<br>
                Nro. de líneas: {{row.lineas | number}} | Total: {{(row.subtotal + row.impuesto) | currency}}<br>

            </div>
            <div class="w-full md:w-6">
                Contacto de Entrega: {{stringToArray(row.idCotizacionNavigation.dataShipping,'||')[0]}}<br>
                Dirección de Entrega: {{stringToArray(row.idCotizacionNavigation.dataShipping,'||')[1]}}<br>
                Ciudad de destino: {{stringToArray(row.idCotizacionNavigation.dataShipping,'||')[2]}}<br>
                Email: {{row.idCotizacionNavigation.correoNotificacion}}<br>
            </div>
            <div class="w-full p-2 flex justify-content-between">
                <div class="p-inputgroup" *ngIf="row.idCotizacionNavigation.estado==2">
                    <div class="p-inputgroup-addon"><i class="pi pi-check-square"></i></div>
                    <p-select [options]="lsStatesQuotation" [(ngModel)]="row.idEstadoSeguimientoCotizacionNavigation"
                        optionLabel="descripcion" placeholder="Seleccione el seguimiento realizado a esta cotización"
                        (onChange)="setTrackingQuotation(row)" />
                </div>

                <div class="p-inputgroup" *ngIf="row.idCotizacionNavigation.estado==2">
                    <button pButton label="Exportar Cotizacion" icon="pi pi-file-export"
                        class="p-button p-button-link text-primary" (click)="getReportQuotation(row)"></button>
                </div>
            </div>
            <div class="w-full">
                <span [innerHTML]="row.message"></span>
            </div>
        </div>
        <ng-template pTemplate="footer">
            <div class="flex gap-3 mt-1">
            </div>
        </ng-template>
    </p-card>
</div>
<p-messages></p-messages>

<p-dialog [(visible)]="displayForwardEmail" [modal]="true" [style]="{width:'80%'}">
    <p-header class="uppercase">
        Reenvío de correo electrónico
    </p-header>
    <span class="p-input-icon-left w-full">
        <i class="pi pi-envelope"></i>
        <input type="email" class="w-full" pInputText [(ngModel)]="txtforwardEmail"
            placeholder="Digie el correo electrónico" />
    </span>
    <span [innerHTML]="rowSelected.message"></span>
    <p-footer>
        <button pButton class="p-button p-button-success" label="Enviar" icon="pi pi-check-circle"
            (click)="forwardEmail(txtforwardEmail, rowSelected)"></button>
    </p-footer>
</p-dialog>